import * as React from 'react';
export const IcInternet = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2a10 10 0 100 20 10 10 0 000-20zm0 18c-.84 0-1.95-1.48-2.55-4h5.1c-.55 2.52-1.71 4-2.55 4zm-2.89-6a18.24 18.24 0 010-4h5.78c.074.664.11 1.332.11 2 0 .668-.036 1.336-.11 2H9.11zM4 12a8.24 8.24 0 01.26-2h2.83C7 10.64 7 11.31 7 12s0 1.36.09 2H4.26A8.24 8.24 0 014 12zm8-8c.84 0 1.95 1.48 2.55 4h-5.1c.6-2.52 1.71-4 2.55-4zm4.91 6h2.83a7.82 7.82 0 010 4h-2.83c.06-.64.09-1.31.09-2s0-1.36-.09-2zm2-2h-2.3a12.788 12.788 0 00-1-3.15A8.1 8.1 0 0118.92 8h-.01zM8.44 4.85A12.79 12.79 0 007.39 8H5.08a8.1 8.1 0 013.36-3.15zM5.08 16h2.31a12.79 12.79 0 001 3.15A8.1 8.1 0 015.08 16zm10.48 3.15a12.788 12.788 0 001-3.15h2.31a8.1 8.1 0 01-3.31 3.15z'
      fill='currentColor'
    />
  </svg>
);
